import {FC, memo, useCallback, useEffect, useState} from 'react'
import {KTSVG} from '../../_metronic/helpers'
import {ContactStatus, GetContactParams, Tag} from '../../services/cellcast.v2.types'
import Select, {Options} from 'react-select'
import {SelectOption} from '../types'
import {useContactFilter} from '../hooks/useContactFilter'
import {Button} from 'react-bootstrap'
import {pick} from 'lodash'
import useResponsive from '../hooks/useResponsive'

type ContactListFilterProps = {
  params: GetContactParams
  setParams: (params: GetContactParams) => void
  doFetchData: () => void
  tags: Tag[]
  showFilterStatus?: boolean
  showFilterTag?: boolean
  groupField?: string[]
}

const ContactListFilter: FC<ContactListFilterProps> = ({
  tags,
  params,
  setParams,
  doFetchData,
  showFilterStatus,
  showFilterTag,
  groupField,
}) => {
  // local state
  const [filterOpen, setFilterOpen] = useState<boolean>(false)
  const [doFetch, setDoFetch] = useState<boolean>(false)
  const filter = useContactFilter()
  const {isMobile} = useResponsive()
  const [filterFields, setFilterFields] = useState<any[]>([])

  // effect
  useEffect(() => {
    filter.actions.setTagOptionFromArr(tags)
  }, [tags])

  // actions
  const handleUpdateStatus = useCallback(
    (option: SelectOption<ContactStatus | string>) => {
      if (option === null) {
        setParams({...params, status: ''})
      } else {
        setParams({...params, status: option.value as ContactStatus})
      }
    },
    [params]
  )

  const handleUpdateTag = useCallback(
    (selectedTags: Options<SelectOption<string>>) => {
      const letTagsIds = selectedTags.filter((el) => el.value !== '')
      const tagArr = letTagsIds.flatMap((el) => el.value)
      if (tagArr.length > 0) {
        const tag = tagArr.join(',')
        setParams({...params, tag: tag})
      } else {
        setParams({...params, tag: ''})
      }
    },
    [params]
  )

  const handleUpdateExcludeTag = useCallback(
    (selectedTags: Options<SelectOption<string>>) => {
      const letTagsIds = selectedTags.filter((el) => el.value !== '')
      const tagArr = letTagsIds.flatMap((el) => el.value)
      if (tagArr.length > 0) {
        const tag = tagArr.join(',')
        setParams({...params, excludeTag: tag})
      } else {
        setParams({...params, excludeTag: ''})
      }
    },
    [params]
  )

  const handleClearFilter = useCallback(() => {
    const paramsData = {
      ...params,
      tag: '',
      excludeTag: '',
      status: '',
      searchFieldsName: '',
      searchFieldsValue: '',
    }

    if (showFilterStatus) {
      setParams(
        pick(paramsData, [
          'groupId',
          'tag',
          'excludeTag',
          'status',
          'searchFieldName',
          'searchFieldsValue',
        ])
      )
    } else {
      setParams(
        pick(paramsData, ['groupId', 'tag', 'excludeTag', 'searchFieldName', 'searchFieldsValue'])
      )
    }
    setFilterFields([])
    setFilterOpen(false)
    setDoFetch(true)
  }, [params, setParams])

  const handleUpdateSearchField = useCallback(
    (option: SelectOption<string>) => {
      if (option === null) {
        setParams({...params, searchFieldsName: ''})
      } else {
        setParams({...params, searchFieldsName: option.value})
      }
    },
    [params, setParams]
  )

  const handleUpdateSearchFieldValue = useCallback(
    (value: string) => {
      if (value === null) {
        setParams({...params, searchFieldsValue: ''})
      } else {
        setParams({...params, searchFieldsValue: value})
      }
    },
    [params, setParams]
  )

  useEffect(() => {
    if (doFetch) {
      doFetchData()
      setDoFetch(false)
    }
  }, [doFetch, doFetchData, params, filterFields])

  return (
    <div className={`d-flex align-items-start position-relative my-1 flex-column flex-sm-row ${isMobile ? 'flex-column' : ''}`}>
      <div className={`relative ${isMobile ? 'w-100' : ''}`}>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6 mt-3'
        />
        <input
          type='text'
          value={params.search ? params.search : ''}
          data-kt-user-table-filter='search'
          className={`form-control form-control-solid ps-14 ${isMobile ? 'w-100' : 'w-250px'}`}
          placeholder='Search user'
          onChange={(e: any) => setParams({...params, search: e.target.value, page: ''})}
          onKeyDown={(e) => e.key === 'Enter' ?  setDoFetch(true) : null}
        />
      </div>
      <div className={isMobile ? 'w-100' : ''}>
        <button
          className={`btn btn-light-primary mt-4 mt-sm-0 ms-0 me-3 ${isMobile ? 'w-100' : ''}`}
          style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
          onClick={() => doFetchData()}
        >
          Search
        </button>
      </div>
      {/* <div
        onMouseEnter={() => setFilterOpen(true)}
        onMouseLeave={() => setFilterOpen(false)}
        className='filter_parent'
      >
        <button
          className={`btn btn-light-primary mt-4 mt-sm-0 ms-0 ms-sm-3 me-3 filter_btn ${
            filterOpen && 'show menu-dropdown'
          } `}
          data-kt-menu-placement='bottom-end'
        >
          <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
          Filter
        </button>
        <div
          className={`menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
            filterOpen && 'show filtermenu'
          }`}
        >
          <div className='px-7 py-5'>
            <div className='mb-10'>
              <div>
                <div className='filter_head mx-n7'>
                  <h4 className='py-2 px-5'>Filter</h4>
                  <hr className='hr' />
                </div>
                {showFilterStatus && (
                  <>
                    <label className='form-label fw-bold'>Status</label>
                    <Select
                      value={
                        params.status
                          ? filter.actions.findStatus(params.status)
                          : {
                              label: 'select status',
                              value: '',
                            }
                      }
                      isClearable={params.status && params.status.length > 0 ? true : false}
                      onChange={(e: any) => handleUpdateStatus(e)}
                      options={filter.state.statusOptions}
                    />
                  </>
                )}

                {showFilterTag && (
                  <>
                    <label className='form-label fw-bold'>Include Tags</label>
                    <Select
                      value={
                        params.tag
                          ? filter.actions.findTags(params.tag.split(','))
                          : {
                              label: 'Select Tags',
                              value: '',
                            }
                      }
                      isClearable={params.tag && params.tag.length > 0 ? true : false}
                      onChange={(e: any) => handleUpdateTag(e)}
                      options={filter.state.tagOptions}
                      isMulti={true}
                    />
                    <label className='form-label fw-bold'>Exclude Tags</label>
                    <Select
                      value={
                        params.excludeTag
                          ? filter.actions.findTags(params.excludeTag.split(','))
                          : {
                              label: 'Select Tags',
                              value: '',
                            }
                      }
                      isClearable={params.excludeTag && params.excludeTag.length > 0 ? true : false}
                      onChange={(e: any) => handleUpdateExcludeTag(e)}
                      options={filter.state.tagOptions}
                      isMulti={true}
                    />
                    <label className='form-label fw-bold mt-2'>Fields</label>
                    <Select
                      options={groupField?.map((it) => ({
                        label: it,
                        value: it,
                      }))}
                      onChange={(e: any) => handleUpdateSearchField(e)}
                    />

                    {params.searchFieldsName && (
                      <input
                        className='form-control mt-2 px-4 min-h-45px'
                        name='field'
                        value={params.searchFieldsValue}
                        onChange={(e) => handleUpdateSearchFieldValue(e.target.value)}
                      />
                    )}

                    {filterFields.map((it, index) => {
                      return (
                        <>
                          <Select
                            options={groupField?.map((it) => ({
                              label: it,
                              value: it,
                            }))}
                            className='mt-2'
                            onChange={(e: any) => {
                              const fields = [...filterFields]
                              fields[index].field = e.value
                              setFilterFields(fields)
                            }}
                          />

                          {it.field && (
                            <input
                              className='form-control mt-2 px-4 min-h-45px'
                              name='field'
                              value={it.value}
                              onChange={(e) => {
                                const fields = [...filterFields]
                                fields[index].value = e.target.value
                                setFilterFields(fields)

                                const transformedObject = fields.reduce((acc, item, index) => {
                                  acc[`searchFieldsNames[${index}]`] = item.field
                                  acc[`searchFieldsValues[${index}]`] = item.value
                                  return acc
                                }, {})

                                setParams({...params, ...transformedObject})
                              }}
                            />
                          )}
                        </>
                      )
                    })}
                    <Button
                      title='Add Another Action'
                      variant='primary'
                      size='sm'
                      className='mt-2'
                      onClick={() => {
                        setFilterFields([...filterFields, {field: '', value: ''}])
                      }}
                    >
                      Add Another Fields
                    </Button>
                  </>
                )}
              </div>
            </div>

            <div className='d-flex justify-content-end'>
              <button
                type='reset'
                className='btn btn-sm gray_bg_purple me-2'
                onClick={() => handleClearFilter()}
              >
                Reset
              </button>

              <button
                type='submit'
                className='btn btn-sm btn-primary'
                data-kt-menu-dismiss='true'
                onClick={() => {
                  doFetchData()
                  setFilterOpen(false)
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

ContactListFilter.defaultProps = {
  showFilterStatus: true,
  showFilterTag: true,
}

export default memo(ContactListFilter)
